import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { ActivityBlock } from '../blocks/ActivityBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

// Vehicle-sourced activities the driver card is missing (card = rest/no-data but the vehicle
// recorded real activity). Rendered as full grayscale blocks (like the vehicles view) on top
// of the card bar at the conflicting times. getActivityColor grays them via isVehicleSource.
const VehicleSourceActivitiesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { vehicleSourceActivities, currentDate } = useTimelineData()

  const [leftPosition, setLeftPosition] = React.useState(0)
  const measure = React.useCallback(
    (node: HTMLDivElement | null) => {
      if (node != null) {
        const rect = node.getBoundingClientRect()
        if (rect.left !== leftPosition) {
          setLeftPosition(rect.left)
        }
      }
    },
    [leftPosition],
  )

  if (!vehicleSourceActivities || vehicleSourceActivities.length === 0) {
    return null
  }

  return (
    <div ref={measure}>
      <LayerWrapper zIndex={zIndex}>
        {vehicleSourceActivities.map((activity, index) => (
          <ActivityBlock
            key={index}
            activity={activity}
            index={index}
            isSelected={false}
            isEditing={false}
            isAddingNew={false}
            currentDate={currentDate}
            parentLeftPosition={leftPosition}
          />
        ))}
      </LayerWrapper>
    </div>
  )
}

export default VehicleSourceActivitiesLayer
